(function () {
  if (window.__BUNDLE_DRAWER_INIT__) return;
  window.__BUNDLE_DRAWER_INIT__ = true;

const PRICES_PER_UNIT = {
  "50ml":  { 1: 299, 2: 285, 3: 275, 4: 265, 5: 255 },
  "100ml": { 1: 399, 2: 379, 3: 365, 4: 350, 5: 340 },
};

  function getSize(overlay) {
    const size = overlay.dataset.size || "100ml";
    return size === "50ml" ? "50ml" : "100ml";
  }

  function getMinQty(overlay) {
    return parseInt(overlay.dataset.minQty || "3", 10);
  }

  function getPPU(qty, size) {
    const tiers = PRICES_PER_UNIT[size] || PRICES_PER_UNIT["100ml"];
    if (qty < 1) return tiers[1];
    if (qty >= 5) return tiers[5];
    return tiers[qty] || tiers[1];
  }

  function getTotalPrice(qty, size) {
    return Math.round(getPPU(qty, size) * qty * 100) / 100;
  }

  function fmtPrice(n) {
    return n % 1 === 0 ? String(n) : n.toFixed(2).replace(".", ",");
  }

  const SYNONYM_GROUPS = [
    ["bergamot", "citrus", "lemon", "orange", "mandarin", "grapefruit", "lime"],
    ["green tea", "grøn te", "tea", "te", "fresh", "clean", "light"],
    ["sandalwood", "sandeltræ", "cedar", "wood", "woody", "vetiver", "oakmoss"],
    ["rose", "jasmine", "peony", "lily", "floral", "flower", "violet"],
    ["musk", "musky", "skin", "soft", "sensual"],
    ["amber", "oriental", "warm", "exotic", "resin"],
    ["vanilla", "sweet", "gourmand", "caramel"],
    ["blackcurrant", "solbær", "cassis", "berry", "fruity"],
    ["apple", "pear", "peach", "apricot"],
    ["petitgrain", "petit grain", "neroli"],
    ["galbanum", "green", "earthy", "herbal"],
    ["spicy", "spice", "pepper", "cinnamon", "cardamom", "clove"],
    ["day", "daytime", "office", "work", "casual"],
    ["night", "evening", "date", "party", "formal"],
    ["summer", "warm weather", "beach", "vacation"],
    ["winter", "cold weather", "cozy", "autumn"],
    ["men", "masculine", "male", "him"],
    ["women", "feminine", "female", "her", "lady"],
    ["unisex", "neutral", "everyone", "all"],
    ["yves saint laurent", "ysl", "saint laurent"],
    ["christian dior", "dior", "cd"],
    ["tom ford", "tf"],
    ["dolce gabbana", "d&g", "dolce & gabbana", "dg"],
    ["calvin klein", "ck"],
    ["hugo boss", "boss", "hugo"],
    ["jean paul gaultier", "jpg", "gaultier"],
    ["maison francis kurkdjian", "mfk", "francis kurkdjian"],
    ["giorgio armani", "armani", "emporio armani"],
    ["jo malone", "jomalone", "jo malone london"],
    ["le labo", "lelabo"],
    ["acqua di parma", "adp"],
    ["viktor rolf", "viktor & rolf"],
    ["carolina herrera", "ch"],
    ["bvlgari", "bulgari", "bvlgari"],
    ["paco rabanne", "rabanne"],
    ["thierry mugler", "mugler"],
    ["chanel", "coco chanel"],
    ["creed", "creed aventus"],
    ["parfums de marly", "de marly", "marly"],
    ["valentino", "valentino beauty"],
    ["givenchy", "givenchy paris"],
    ["guerlain", "guerlain paris"],
    ["versace", "versace perfume"],
    ["burberry", "burberry london"],
    ["montblanc", "mont blanc"],
    ["narciso rodriguez", "narciso"],
    ["viktor & rolf", "flowerbomb"],
    ["lancome", "lancôme"],
    ["hermes", "hermès", "hermes paris"],
  ];

  const synonymMap = new Map();
  SYNONYM_GROUPS.forEach((group) =>
    group.forEach((word) => synonymMap.set(word, group))
  );

  function expandQuery(raw) {
    const q = raw.trim().toLowerCase();
    const terms = new Set([q]);
    const syns = synonymMap.get(q);
    if (syns) syns.forEach((s) => terms.add(s));
    return terms;
  }

  function getTotalSelected(overlay) {
    let total = 0;
    overlay
      .querySelectorAll(".custom-quantity-selector:not(.hidden) .quantity-value")
      .forEach((el) => {
        total += parseInt(el.textContent || "0", 10);
      });
    return total;
  }

  function collectSelections(overlay) {
    const items = [];
    overlay.querySelectorAll(".bundle-product").forEach((card) => {
      const sel = card.querySelector(
        ".custom-quantity-selector:not(.hidden)[data-selected]"
      );
      if (!sel) return;
      const qty = parseInt(sel.querySelector(".quantity-value")?.textContent || "0", 10);
      const variantId = sel.dataset.variantId || "";
      const imgEl = card.querySelector(".bundle-product-image img");
      const imgSrc = imgEl ? imgEl.src : "";
      const title = card.querySelector(".product-title")?.textContent?.trim() || "";
      const gender = card.dataset.gender || "";
      if (qty > 0 && variantId) {
        for (let i = 0; i < qty; i++) {
          items.push({ variantId, imgSrc, title, gender });
        }
      }
    });
    return items;
  }

  function getMainProductForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function injectFormInputs(overlay) {
    const form = getMainProductForm();
    if (!form) return;
    form.querySelectorAll(
      'input[name="id"], input[name="quantity"], input[name^="items["]'
    ).forEach((el) => el.remove());
    const selections = collectSelections(overlay);
    selections.forEach((item, i) => {
      const idInput = document.createElement("input");
      idInput.type = "hidden";
      idInput.name = `items[${i}][id]`;
      idInput.value = item.variantId;
      idInput.setAttribute("data-bundle-injected", "true");
      form.appendChild(idInput);
      const qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = `items[${i}][quantity]`;
      qtyInput.value = "1";
      qtyInput.setAttribute("data-bundle-injected", "true");
      form.appendChild(qtyInput);
    });
  }

  function clearInjectedInputs() {
    const form = getMainProductForm();
    if (!form) return;
    form.querySelectorAll("[data-bundle-injected]").forEach((el) => el.remove());
  }

  function getMainSubmitButtons(form) {
    if (!form) return [];
    return Array.from(form.querySelectorAll('button[type="submit"][name="add"], input[type="submit"][name="add"]'));
  }

  function renderBundleSlots(overlay) {
    const wrap = overlay.querySelector(".bundle-boxes");
    const scrollWrap = overlay.querySelector(".bundle-boxes-wrap");
    const indicator = overlay.querySelector(".bundle-scroll-indicator");
    const thumb = overlay.querySelector(".bundle-scroll-thumb");
    if (!wrap) return;

    const selections = collectSelections(overlay);
    const qty = selections.length;
    const MIN_QTY = getMinQty(overlay);
    const total = Math.max(MIN_QTY, qty);
    const isScroll = qty > 4;

    wrap.innerHTML = "";
    wrap.style.width = isScroll ? "max-content" : "100%";

    for (let i = 0; i < total; i++) {
      const filled = i < qty;
      const item = filled ? selections[i] : null;
      const slot = document.createElement("div");
      slot.className = "bundle-slot" + (filled ? " filled" : "") + (isScroll ? " scroll-mode" : "");

      if (filled && item.imgSrc) {
        const img = document.createElement("img");
        img.className = "bundle-slot-img";
        img.src = item.imgSrc;
        img.alt = item.title;
        slot.appendChild(img);
      } else {
        const placeholder = document.createElement("div");
        placeholder.className = "bundle-slot-placeholder";
        placeholder.innerHTML = `<svg width="36" height="52" viewBox="0 0 24 40" fill="none"><rect x="8" y="0" width="8" height="5" rx="2" fill="#555"/><rect x="5" y="5" width="14" height="30" rx="3" fill="#d8d8d8" stroke="#bbb" stroke-width="1"/><rect x="7" y="11" width="10" height="14" rx="1" fill="#f5f5f5" stroke="#ddd" stroke-width=".5"/></svg>`;
        slot.appendChild(placeholder);
      }

      const lbl = document.createElement("span");
      lbl.className = "bundle-slot-lbl";
      lbl.textContent = filled ? item.title.split(" ")[0] : "";
      if (filled) {
        const g = item.gender || "";
        if (g === "feminin") lbl.style.color = "#ec4899";
        else if (g === "maskulin") lbl.style.color = "#3b82f6";
        else if (g === "unisex") lbl.style.color = "#d97706";
        else lbl.style.color = "#4D903F";
      }
      slot.appendChild(lbl);

      if (filled) {
        const removeBtn = document.createElement("div");
        removeBtn.className = "bundle-slot-remove";
        removeBtn.innerHTML = `<svg width="7" height="7" viewBox="0 0 10 10" fill="none"><path d="M1 1l8 8M9 1l-8 8" stroke="#fff" stroke-width="2"/></svg>`;
        removeBtn.addEventListener("click", (e) => { e.stopPropagation(); removeSlotItem(overlay, i); });
        slot.appendChild(removeBtn);
      }

      const col = document.createElement("div");
      col.className = "bundle-slot-col" + (isScroll ? " scroll-mode" : "");
      col.appendChild(slot);

      const num = document.createElement("span");
      num.className = "bundle-slot-num" + (filled ? " filled" : "");
      num.textContent = (i + 1) + "";
      col.appendChild(num);

      wrap.appendChild(col);
    }

    if (indicator && thumb && scrollWrap) {
      if (isScroll) {
        indicator.classList.add("visible");
        const updateThumb = () => {
          const ratio = scrollWrap.clientWidth / scrollWrap.scrollWidth;
          const thumbW = Math.max(20, ratio * 100);
          const maxScroll = scrollWrap.scrollWidth - scrollWrap.clientWidth;
          const scrollPct = maxScroll > 0 ? scrollWrap.scrollLeft / maxScroll : 0;
          const thumbLeft = scrollPct * (100 - thumbW);
          thumb.style.width = thumbW + "%";
          thumb.style.marginLeft = thumbLeft + "%";
        };
        scrollWrap.addEventListener("scroll", updateThumb, { passive: true });
        setTimeout(() => { scrollWrap.scrollLeft = scrollWrap.scrollWidth; updateThumb(); }, 60);
      } else {
        indicator.classList.remove("visible");
        thumb.style.width = "100%";
        thumb.style.marginLeft = "0%";
      }
    }
  }

  function removeSlotItem(overlay, slotIndex) {
    const selections = collectSelections(overlay);
    if (slotIndex >= selections.length) return;
    const targetVariantId = selections[slotIndex].variantId;
    let removed = false;
    overlay.querySelectorAll(".bundle-product").forEach((card) => {
      if (removed) return;
      const sel = card.querySelector(".custom-quantity-selector:not(.hidden)[data-selected]");
      if (!sel || sel.dataset.variantId !== targetVariantId) return;
      const qtyVal = sel.querySelector(".quantity-value");
      let val = parseInt(qtyVal?.textContent || "0", 10);
      if (val <= 0) return;
      val--;
      removed = true;
      if (qtyVal) qtyVal.textContent = String(val);
      if (val === 0) {
        const addBtn = card.querySelector(".add-bundle");
        sel.classList.add("hidden");
        sel.removeAttribute("data-selected");
        if (addBtn) addBtn.classList.remove("hidden");
        card.classList.remove("selected");
      }
    });
    refreshAllStates(overlay);
  }

  function updateTiers(overlay) {
    const qty = getTotalSelected(overlay);
    const size = getSize(overlay);
    const MIN_QTY = getMinQty(overlay);
    const prices = PRICES_PER_UNIT[size];
    const tiers = overlay.querySelectorAll(".bundle-tier");

    if (MIN_QTY === 4) {
      const tierPrices = [prices[4], prices[5]];
      const tierThresholds = [4, 5];
      tiers.forEach((tier, i) => {
        tier.classList.toggle("active", qty >= tierThresholds[i]);
        const priceEl = tier.querySelector(".bundle-tier-price");
        if (priceEl && tierPrices[i]) priceEl.textContent = fmtPrice(tierPrices[i]) + " kr.";
      });
    } else {
      const tierPrices = [prices[3], prices[4], prices[5]];
      const tierThresholds = [3, 4, 5];
      tiers.forEach((tier, i) => {
        tier.classList.toggle("active", qty >= tierThresholds[i]);
        const priceEl = tier.querySelector(".bundle-tier-price");
        if (priceEl && tierPrices[i]) priceEl.textContent = fmtPrice(tierPrices[i]) + " kr.";
      });
    }
  }

  function updateProgressBar(overlay) {
    const qty = getTotalSelected(overlay);
    const size = getSize(overlay);
    const MIN_QTY = getMinQty(overlay);
    const bar = overlay.querySelector(".bundle-progress-bar");
    const label = overlay.querySelector(".bundle-progress-label");
    if (!bar) return;
    const prices = PRICES_PER_UNIT[size];

    bar.style.setProperty("width", Math.min(100, (qty / 5) * 100) + "%", "important");
    if (!label) return;

    if (qty < MIN_QTY) {
      label.innerHTML = `Lägg till <span>${MIN_QTY - qty} till</span> för rabatt`;
    } else if (qty === 3 && MIN_QTY === 3) {
      label.innerHTML = `+1 → <span>${fmtPrice(prices[4])} kr/st</span>`;
    } else if (qty === 4) {
      label.innerHTML = `+1 → <span>${fmtPrice(prices[5])} kr/st</span>`;
    } else {
      label.innerHTML = `<span>✓ Bästa pris!</span>`;
    }
  }

  function updateCounter(overlay) {
    const MIN_QTY = getMinQty(overlay);
    const counter = overlay.querySelector(".bundle-counter");
    if (!counter) return;
    const qty = getTotalSelected(overlay);
    const needMore = MIN_QTY - qty;
    const arrowUp = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#4D903F" stroke-width="2.5" style="flex-shrink:0"><path d="M12 5v14M5 12l7-7 7 7"/></svg>`;
    const checkIcon = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#4D903F" stroke-width="2.5" style="flex-shrink:0"><path d="M20 6L9 17l-5-5"/></svg>`;

    if (qty < MIN_QTY) {
      counter.innerHTML = `${arrowUp} Lås upp din rabatt med <strong>${needMore} till</strong>`;
    } else if (qty === 3 && MIN_QTY === 3) {
      counter.innerHTML = `${arrowUp} Lägg till <strong>1 till</strong> och spara extra`;
    } else if (qty === 4) {
      counter.innerHTML = `${arrowUp} En till och du når <strong>lägsta priset</strong>`;
    } else {
      counter.innerHTML = `${checkIcon} Bästa pris! Ta fler till samma låga pris`;
    }
    counter.style.display = "flex";
  }

  function updateConfirmButton(overlay) {
    const MIN_QTY = getMinQty(overlay);
    const qty = getTotalSelected(overlay);
    const size = getSize(overlay);
    const total = getTotalPrice(qty, size);
    const btn = overlay.querySelector(".bundle-add-to-cart");
    if (!btn) return;
    if (qty < MIN_QTY) {
      btn.disabled = true;
      btn.style.opacity = "";
      btn.style.pointerEvents = "";
      const remaining = MIN_QTY - qty;
      btn.innerHTML = remaining === MIN_QTY
        ? `LÄGG TILL MINST ${MIN_QTY} FÖR ATT FORTSÄTTA`
        : `LÄGG TILL ${remaining} TILL FÖR ATT FORTSÄTTA`;
    } else {
      btn.disabled = false;
      btn.style.opacity = "";
      btn.style.pointerEvents = "";
      btn.innerHTML = `LÄGG I VARUKORG &nbsp;—&nbsp; <span class="bundle-btn-total">${fmtPrice(total)} kr.</span>`;
    }
  }

  function updateMainProductSubmitState(overlay) {
    const MIN_QTY = getMinQty(overlay);
    const form = getMainProductForm();
    if (!form) return;
    const buttons = getMainSubmitButtons(form);
    if (!buttons.length) return;
    const qty = getTotalSelected(overlay);
    const size = getSize(overlay);
    const remaining = MIN_QTY - qty;
    const total = getTotalPrice(qty, size);

    const list = document.querySelector(".bundle-selected-list");
    let errorEl = document.querySelector("[data-bundle-main-error]");
    if (!errorEl) {
      errorEl = document.createElement("div");
      errorEl.setAttribute("data-bundle-main-error", "true");
      if (list) list.appendChild(errorEl);
    }

    buttons.forEach((btn) => {
      if (remaining > 0) {
        btn.disabled = true;
        btn.classList.add("disabled");
        btn.style.pointerEvents = "none";
        btn.style.opacity = "0.6";
        errorEl.className = "bundle-main-error";
        errorEl.textContent = `Lägg till ${remaining} produkt${remaining > 1 ? "er" : ""} i paketet för att fortsätta.`;
        errorEl.style.display = "block";
      } else {
        btn.disabled = false;
        btn.classList.remove("disabled");
        btn.style.pointerEvents = "";
        btn.style.opacity = "1";
        errorEl.className = "bundle-success-message";
        errorEl.textContent = `🎉 Paketet klart! Totalt: ${fmtPrice(total)} kr.`;
        errorEl.style.display = "block";
        btn.addEventListener("click", () => {
          setTimeout(() => { resetDrawerSelections(overlay); refreshAllStates(overlay); }, 500);
        });
      }
    });
  }

  function syncCapState(overlay) {
    overlay.querySelectorAll(".add-bundle:not(.hidden)").forEach((btn) => {
      if (!btn.classList.contains("unavailable")) { btn.disabled = false; btn.classList.remove("disabled"); }
    });
  }

  function refreshAllStates(overlay) {
    injectFormInputs(overlay);
    renderBundleSlots(overlay);
    updateTiers(overlay);
    updateProgressBar(overlay);
    updateCounter(overlay);
    syncCapState(overlay);
    updateConfirmButton(overlay);
    updateMainProductSubmitState(overlay);
  }

  function resetDrawerSelections(overlay) {
    overlay.querySelectorAll(".bundle-product").forEach((card) => {
      const sel = card.querySelector(".custom-quantity-selector");
      const addBtn = card.querySelector(".add-bundle");
      const qtyVal = sel?.querySelector(".quantity-value");
      if (sel) { sel.classList.add("hidden"); sel.removeAttribute("data-selected"); }
      if (addBtn) { addBtn.classList.remove("hidden"); if (!addBtn.classList.contains("unavailable")) { addBtn.disabled = false; addBtn.classList.remove("disabled"); } }
      if (qtyVal) qtyVal.textContent = "1";
      card.classList.remove("selected");
    });
  }

  function resetBundleState(overlay) {
    resetDrawerSelections(overlay);
    clearInjectedInputs();
    refreshAllStates(overlay);
  }

  function openDrawer(overlay) {
    overlay.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer(overlay) {
    overlay.classList.add("hidden");
    document.body.style.overflow = "";
    renderSelectedList(overlay);
  }

  function renderSelectedList(overlay) {
    const list = document.querySelector(".bundle-selected-list");
    if (!list) return;

    const errorEl = list.querySelector("[data-bundle-main-error]");
    const MIN_QTY = getMinQty(overlay);
    const selections = collectSelections(overlay);
    const total = Math.max(MIN_QTY, selections.length);
    list.innerHTML = "";

    for (let i = 0; i < total; i++) {
      const item = selections[i] || null;
      const filled = !!item;

      const row = document.createElement("div");
      row.className = "bundle-selected-item" + (filled ? " is-filled" : "");
      row.addEventListener("click", () => openDrawer(overlay));

      const iconWrap = document.createElement("div");
      iconWrap.className = "bundle-selected-item-icon";

      if (filled && item.imgSrc) {
        const img = document.createElement("img");
        img.className = "bundle-selected-item-img";
        img.src = item.imgSrc;
        img.alt = item.title;
        iconWrap.style.border = "none";
        iconWrap.style.background = "#fff";
        iconWrap.appendChild(img);
      } else {
        iconWrap.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5"><path d="M12 5v14M5 12h14"/></svg>`;
      }
      row.appendChild(iconWrap);

      const name = document.createElement("span");
      name.className = "bundle-selected-item-name";
      name.textContent = filled ? item.title : `Välj parfym ${i + 1}`;
      row.appendChild(name);

      if (filled) {
        const edit = document.createElement("span");
        edit.className = "bundle-selected-item-edit";
        edit.textContent = "Ändra →";
        row.appendChild(edit);
      }

      list.appendChild(row);
    }

    if (errorEl) list.appendChild(errorEl);
  }

  function showDrawerError(overlay, msg) {
    let errEl = overlay.querySelector(".bundle-drawer-error");
    if (!errEl) {
      errEl = document.createElement("p");
      errEl.className = "bundle-drawer-error";
      errEl.style.cssText = "color:red;font-size:13px;margin:6px 0 0;";
      overlay.querySelector(".bundle-drawer-footer")?.prepend(errEl);
    }
    errEl.textContent = msg;
    errEl.style.display = "block";
    setTimeout(() => (errEl.style.display = "none"), 4000);
  }

  async function addBundleToCart(overlay) {
    const MIN_QTY = getMinQty(overlay);
    const selections = collectSelections(overlay);
    if (selections.length < MIN_QTY) { showDrawerError(overlay, `Lägg till minst ${MIN_QTY} produkter för att fortsätta.`); return; }
    const btn = overlay.querySelector(".bundle-add-to-cart");
    if (btn) { btn.disabled = true; btn.classList.add("loading"); btn.dataset.originalHtml = btn.innerHTML; btn.innerHTML = `<span class="bundle-btn-spinner" aria-hidden="true"></span><span>Lägger till...</span>`; }
    const params = new URLSearchParams();
    selections.forEach((item, i) => { params.append(`items[${i}][id]`, item.variantId); params.append(`items[${i}][quantity]`, "1"); });
    try {
      const res = await fetch("/cart/add", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json" }, body: params.toString() });
      if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || `HTTP ${res.status}`); }
      const data = await res.json();
      console.log("[BUNDLE DRAWER] ✅ Added to cart:", data);
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      if (btn) { btn.classList.remove("loading"); btn.classList.add("success"); btn.innerHTML = `<span>✓ Tillagd!</span>`; }
      await new Promise((resolve) => setTimeout(resolve, 800));
      const cartDrawerEl = document.querySelector("cart-drawer");
      if (cartDrawerEl && typeof cartDrawerEl.open === "function") { cartDrawerEl.open(); }
      else {
        const trigger = document.querySelector("[data-cart-drawer-toggle]") || document.querySelector(".cart-icon-bubble") || document.querySelector('[aria-controls="CartDrawer"]');
        if (trigger) trigger.click();
      }
      resetBundleState(overlay);
      closeDrawer(overlay);
    } catch (err) {
      console.error("[BUNDLE DRAWER] Add to cart failed:", err);
      showDrawerError(overlay, err.message || "Något gick fel. Försök igen.");
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove("loading", "success"); btn.innerHTML = btn.dataset.originalHtml || "Lägg i varukorg"; delete btn.dataset.originalHtml; }
    }
  }

  function initDrawer(overlay) {
    const drawer = overlay.querySelector(".bundle-drawer");
    const closeBtn = overlay.querySelector(".bundle-drawer-close");
    const searchInput = overlay.querySelector(".bundle-search-input");
    const productCards = Array.from(overlay.querySelectorAll(".bundle-product"));

    closeBtn?.addEventListener("click", () => closeDrawer(overlay));
    overlay.addEventListener("click", (e) => { if (drawer && !drawer.contains(e.target)) closeDrawer(overlay); });

    const productIndex = productCards.map((el) => {
      let rawBrand = (el.dataset.brandName || "").trim();
      let brandStr = rawBrand;
      if (rawBrand.startsWith("[")) {
        try { const parsed = JSON.parse(rawBrand); brandStr = Array.isArray(parsed) ? parsed.join(",") : rawBrand; }
        catch(e) { brandStr = rawBrand.replace(/[\[\]"]/g, ""); }
      }
      return {
        el,
        title: (el.querySelector(".product-title")?.textContent || "").trim().toLowerCase(),
        subtitle: (el.querySelector(".product-subtitle")?.textContent || "").trim().toLowerCase(),
        notes: [el.dataset.topNotes || "", el.dataset.middleNotes || "", el.dataset.bottomNotes || ""].join(" ").toLowerCase(),
        brand: brandStr.toLowerCase(),
        gender: (el.dataset.gender || "").trim().toLowerCase(),
      };
    });

    productIndex.forEach(({ brand }) => {
      if (!brand) return;
      brand.split(",").map(b => b.trim()).filter(Boolean).forEach(b => { if (!synonymMap.has(b)) synonymMap.set(b, [b]); });
    });

    const uniqueBrands = new Set();
    productIndex.forEach(({ brand }) => {
      if (!brand) return;
      brand.split(",").map(b => b.trim().toLowerCase()).filter(Boolean).forEach(b => uniqueBrands.add(b));
    });
    uniqueBrands.forEach(brand => {
      if (!synonymMap.has(brand)) synonymMap.set(brand, [brand]);
      brand.split(" ").filter(w => w.length > 2).forEach(word => {
        if (!synonymMap.has(word)) synonymMap.set(word, [brand]);
        else { const existing = synonymMap.get(word); if (!existing.includes(brand)) existing.push(brand); }
      });
    });

    const productWrapper = overlay.querySelector(".bundle-product-wrapper");
    function sortProducts() {
      if (!productWrapper) return;
      const cards = Array.from(productWrapper.querySelectorAll(".bundle-product"));
      const selected = cards.filter(c => c.classList.contains("selected"));
      const available = cards.filter(c => !c.classList.contains("selected") && !c.classList.contains("unavailable"));
      const unavailable = cards.filter(c => c.classList.contains("unavailable"));
      [...selected, ...available, ...unavailable].forEach(c => productWrapper.appendChild(c));
    }
    sortProducts();

    const recentlySelected = new Set();
    if (productWrapper) {
      productWrapper.addEventListener("scroll", () => {
        if (recentlySelected.size === 0) return;
        const wrapperTop = productWrapper.getBoundingClientRect().top;
        recentlySelected.forEach((card) => {
          const cardBottom = card.getBoundingClientRect().bottom;
          if (cardBottom < wrapperTop) { recentlySelected.delete(card); sortProducts(); }
        });
      }, { passive: true });
    }

    let activeGender = "all";

    function applyFilters(rawQuery) {
      const q = (rawQuery || "").trim().toLowerCase();
      if (!q) {
        productIndex.forEach(({ el, gender }) => {
          const genderOk = activeGender === "all" || gender === activeGender || gender === "unisex";
          el.style.display = genderOk ? "" : "none";
        });
        return;
      }
      const terms = expandQuery(q);
      productIndex.forEach(({ el, title, subtitle, notes, brand, gender }) => {
        const genderOk = activeGender === "all" || gender === activeGender || gender === "unisex";
        const combined = `${title} ${subtitle} ${notes} ${brand}`;
        const directMatch = combined.includes(q);
        const synonymMatch = Array.from(terms).some((t) => combined.includes(t));
        el.style.display = genderOk && (directMatch || synonymMatch) ? "" : "none";
      });
    }

    overlay.querySelectorAll(".bundle-filter-chip").forEach((chip) => {
      chip.addEventListener("click", (e) => {
        e.preventDefault();
        overlay.querySelectorAll(".bundle-filter-chip").forEach((c) => c.classList.remove("active"));
        chip.classList.add("active");
        activeGender = chip.dataset.filter || "all";
        if (searchInput) searchInput.value = "";
        applyFilters("");
      });
    });

    if (searchInput) {
      const clearBtn = overlay.querySelector(".bundle-search-clear");
      let debounce;
      const updateClearBtn = (val) => { if (clearBtn) clearBtn.style.display = val ? "flex" : "none"; };
      searchInput.addEventListener("input", (e) => { clearTimeout(debounce); updateClearBtn(e.target.value); debounce = setTimeout(() => applyFilters(e.target.value), 120); });
      searchInput.addEventListener("keydown", (e) => { if (e.key === "Escape") { searchInput.value = ""; updateClearBtn(""); applyFilters(""); } });
      clearBtn?.addEventListener("click", () => { searchInput.value = ""; updateClearBtn(""); applyFilters(""); searchInput.focus(); });
      initAnimatedPlaceholder(searchInput, ["efter varumärke...", '"Sauvage"...', '"Libre"...', '"Vanilla 28"...']);
    }

    overlay.querySelectorAll(".custom-quantity-selector").forEach((sel) => {
      const minusBtn = sel.querySelector("button:first-child");
      const plusBtn = sel.querySelector("button:last-child");
      const qtyVal = sel.querySelector(".quantity-value");
      minusBtn?.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        let val = parseInt(qtyVal.textContent || "0", 10);
        if (val <= 0) return;
        val--;
        qtyVal.textContent = String(val);
        if (val === 0) {
          const parent = sel.closest(".bundle-product");
          const addBtn = parent?.querySelector(".add-bundle");
          sel.classList.add("hidden"); sel.removeAttribute("data-selected");
          if (addBtn) addBtn.classList.remove("hidden");
          parent?.classList.remove("selected");
        }
        refreshAllStates(overlay);
      });
      plusBtn?.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        let val = parseInt(qtyVal.textContent || "0", 10);
        qtyVal.textContent = String(val + 1);
        refreshAllStates(overlay);
      });
    });

    overlay.querySelectorAll(".add-bundle").forEach((addBtn) => {
      addBtn.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        const parent = addBtn.closest(".bundle-product");
        const sel = parent?.querySelector(".custom-quantity-selector");
        const qtyVal = sel?.querySelector(".quantity-value");
        if (!sel) return;
        addBtn.classList.add("hidden");
        sel.classList.remove("hidden");
        sel.setAttribute("data-selected", "true");
        if (qtyVal) qtyVal.textContent = "1";
        parent?.classList.add("selected");
        if (parent) recentlySelected.add(parent);
        refreshAllStates(overlay);
      });
    });

    overlay.querySelector(".bundle-add-to-cart")?.addEventListener("click", async () => { await addBundleToCart(overlay); });

    refreshAllStates(overlay);
  }

  function initAnimatedPlaceholder(input, phrases) {
    let phraseIndex = 0, charIndex = 0, isDeleting = false;
    function type() {
      if (document.activeElement === input) { setTimeout(type, 400); return; }
      const current = phrases[phraseIndex];
      if (isDeleting) charIndex--; else charIndex++;
      input.placeholder = "🔎 Sök " + current.substring(0, charIndex);
      let delay = isDeleting ? 40 : 80;
      if (!isDeleting && charIndex === current.length) { delay = 1800; isDeleting = true; }
      else if (isDeleting && charIndex === 0) { isDeleting = false; phraseIndex = (phraseIndex + 1) % phrases.length; delay = 400; }
      setTimeout(type, delay);
    }
    setTimeout(type, 800);
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".bundle-select-overlay").forEach((overlay) => {
      initDrawer(overlay);
      renderSelectedList(overlay);
    });
    document.querySelectorAll("[data-bundle-options]").forEach((container) => {
      const section = container.closest(".shopify-section") || container.closest("[data-section-type]") || container.parentElement;
      const overlay = section?.querySelector(".bundle-select-overlay");
      if (!overlay) return;
      container.querySelectorAll(".bundle-option-button").forEach((btn) => {
        btn.addEventListener("click", () => openDrawer(overlay));
      });
    });
    console.log("[BUNDLE DRAWER] ✅ Initialized");
  });
})();